import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const next = location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate(next, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto py-16 animate-fade-in">
      <Card className="p-8 bg-white border-forest/10">
        <div className="flex items-center gap-2 text-forest mb-2">
          <LogIn className="w-4 h-4" /> <span className="text-xs uppercase tracking-[0.2em] font-medium">Sign in</span>
        </div>
        <h1 className="font-heading text-3xl font-semibold text-forest mb-6">Welcome back</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium mb-1 block">Email</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm font-medium mb-1 block">Password</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-forest hover:bg-forest/90 text-bone" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-center mt-6 text-muted-foreground">
          New here? <Link to="/signup" state={{ from: next }} className="text-forest font-medium hover:underline">Create an account</Link>
        </p>
      </Card>
    </div>
  );
}
